module.exports = __webpack_public_path__ + "47788aee14f7bdc483fef33fde80cc06.MP3";